import { useRef, useEffect } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";

import "./Shipping.scss";

import Schedule from "./Schedule/Schedule";
import LabelAvailability from "./LabelAvailability/LabelAvailability";

const Shipping = () => {
  const history = useHistory();
  const location = useLocation();
  const tabs = {
    schedule: useRef(),
    // financial: useRef(),
    labelAvailability: useRef(),
  };

  useEffect(() => {
    Object.keys(tabs).forEach((item) => {
      tabs[item].current.classList.remove("selected");
    });
    const { pathname } = location;
    switch (pathname) {
      // case "/shipping/financial":
      //   tabs.financial.current.classList.add("selected");
      //   break;
      case "/shipping/label-availability":
        tabs.labelAvailability.current.classList.add("selected");
        break;
      case "/shipping/schedule-documents":
        tabs.schedule.current.classList.add("selected");
        break;
      default:
        tabs.schedule.current.classList.add("selected");
    }
  }, [location]);

  const handleTabClick = (tab) => {
    Object.keys(tabs).forEach((item) => {
      tabs[item].current.classList.remove("selected");
    });

    switch (tab) {
      case 1:
        history.push("/shipping/schedule-documents");
        tabs.schedule.current.classList.add("selected");
        break;
      // case 2:
      //   history.push("/shipping/financial");
      //   tabs.financial.current.classList.add("selected");
      //   break;
      case 2:
        history.push("/shipping/label-availability");
        tabs.labelAvailability.current.classList.add("selected");
        break;
      default:
    }
  };

  return (
    <div className='pageContent'>
      <div className='componentContent'>
        <ul className='tabs'>
          <li
            ref={tabs.schedule}
            onClick={() => {
              handleTabClick(1);
            }}
          >
            Shipping Schedule
          </li>
{/*          <li
            ref={tabs.financial}
            onClick={() => {
              handleTabClick(2);
            }}
          >
            Prepayment
          </li>*/}
          <li
            ref={tabs.labelAvailability}
            onClick={() => {
              handleTabClick(2);
            }}
          >
            Labels & Spec
          </li>
        </ul>
        <Switch>
          <Route exact path='/shipping/schedule-documents'>
            <Schedule />
          </Route>
          {/* <Route exact path='/shipping/financial'>
            <Financial />
          </Route> */}
          <Route exact path='/shipping/label-availability'>
            <LabelAvailability />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default Shipping;